export const version = '0.806.1-SNAPSHOT'
export const chameleonWebVersion = '10.3.1'
export const chameleonCoreVersion = '7.12.1'
